export const DIALOG_TYPES = {
    MARGIN: 'margin',
    ANIMATE: 'animate',
    CONDITIONS: 'conditions'
};
